// i18n cho thanh PlatformTabNav (chuyển Tài khoản ↔ Bài viết của 1 nền tảng).
const fragment = {
  vi: {
    'platformTabs.accounts': 'Tài khoản',
    'platformTabs.posts': 'Bài viết',
  },
  en: {
    'platformTabs.accounts': 'Accounts',
    'platformTabs.posts': 'Posts',
  },
};

export default fragment;
